import {Controller} from '@hotwired/stimulus';

// Un plugin de la ligne Plugins d'un formulaire d'édition : sa case et ses réglages sont toujours affichés,
// préremplis avec la valeur héritée quand rien n'est réglé à ce niveau. Le plugin n'est réglé à ce niveau
// (`thisLevelEnabled`, `custom_<id>` sur un écran legacy) que si l'on y touche ; revenir aux valeurs d'origine le
// laisse hériter. Un plugin déjà réglé à ce niveau le reste. Les champs cachés n'entrent pas dans la comparaison :
// seuls les scripts du plugin les écrivent (options de service des commentaires legacy).
export default class extends Controller {
  static targets = ['customized'];

  connect() {
    this.initiallyCustomized = this.customizedTarget.value === '1';

    // un écran legacy remplit certains réglages par script au chargement (liste des services des commentaires)
    if (document.readyState === 'complete') {
      this.initial = this.snapshot();
    } else {
      window.addEventListener('load', () => {
        this.initial ??= this.snapshot();
      }, {once: true});
    }

    // les réglages d'un plugin coupé restent masqués : js-shownextdiv (interface.js) les replie au chargement par un
    // slideUp, sans effet dans le panneau fermé de la ligne ; il reprend la main au premier changement
    this.element.querySelectorAll('.js-shownextdiv').forEach((input) => {
      const settings = input.closest('.form-row, .control-group')?.nextElementSibling;

      if (settings && !input.checked) {
        settings.style.display = 'none';
      }
    });
  }

  update() {
    // touché avant la fin du chargement : réglé à ce niveau, sans état d'origine auquel revenir
    this.initial ??= null;
    this.customizedTarget.value = this.initiallyCustomized || this.snapshot() !== this.initial ? '1' : '0';
  }

  snapshot() {
    return JSON.stringify([...this.element.querySelectorAll('input, select, textarea')]
      .filter((field) => field.type !== 'hidden' && field.name !== '')
      .map((field) => (['checkbox', 'radio'].includes(field.type) ? field.checked : field.value)));
  }
}
